import React, { Component } from 'react';
import ReactGA from 'react-ga';
import $ from 'jquery';
import axios from 'axios';
import {ToastContainer, toast } from 'react-toastify';
  import 'react-toastify/dist/ReactToastify.css';
// import userData from './myData/resumeData.json';
import './App.css';
import Header from './Components/Header';
import Footer from './Components/Footer';
import About from './Components/About';
import Resume from './Components/Resume';
import Contact from './Components/Contact';
import Testimonials from './Components/Testimonials';
import Portfolio from './Components/Portfolio';
import { myResumeUrl } from './config.js/Config';

class App extends Component {

  constructor(props){
    super(props);
    this.state = {
      foo: 'bar',
      resumeData: {}
    };

    // ReactGA.initialize('UA-110570651-1');
    // ReactGA.pageview(window.location.pathname);

  }

  async getResumeData(){
    const notify = (res) => toast.error(res);
    let url = myResumeUrl + "/resumedata";
    try {
      let res = await axios.get(url);
      let data = await res.data;
      console.log("Resume Data: ", data);
    this.setState({resumeData:data});
    } catch (error) {
      notify("Server not response")
      console.log("Error: ", error);
    this.setState({resumeData:{}});
    }
  }
    async getResumeDataTestinomial(){
      // const notify = (res) => toast.error(res);
      let url = myResumeUrl;
      try {
        let res = await axios.get(url);
        let data = await res.data;
        console.log("Resume Data testinomial: ", data);
      // this.setState({resumeData:data});
      } catch (error) {
        // notify("Server not response")
        console.log("Error: ", error);
      // this.setState({resumeData:{}});
      }
  }
    // this.setState({resumeData:userData});
    // $.ajax({
    //   url:'/resumeData.json',
    //   dataType:'json',
    //   cache: false,
    //   success: function(data){
    //     this.setState({resumeData: data});
    //   }.bind(this),
    //   error: function(xhr, status, err){
    //     console.log(err);
    //     alert(err);
    //   }
    // });

  componentDidMount(){
    this.getResumeData();
    // this.getResumeDataTestinomial()
  }
  render() {
    // console.log("user data : ", userData);
    return (
      <div className="App">
                    <ToastContainer
            position="top-left"
            autoClose={3000}
            hideProgressBar={true}
            newestOnTop={false}
            closeOnClick={false}
            rtl={false}
            pauseOnFocusLoss
            draggable={false}
            pauseOnHover
            closeButton={false}
            // toastClassName={'danger'}
            />
        <Header data={this.state.resumeData.main}/>
        <About data={this.state.resumeData.main}/>
        <Resume data={this.state.resumeData.resume}/>
        {/* <Portfolio data={this.state.resumeData.portfolio}/> */}
        <Testimonials data={this.state.resumeData.testimonials}/>
        <Contact data={this.state.resumeData.main}/>
        <Footer data={this.state.resumeData.main}/>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js